const userEl = document.querySelector("#current-user-info-container");
LogRocket.identify(userEl?.getAttribute("user_id"), {
  name: userEl?.getAttribute("name"),
  email: userEl?.getAttribute("email"),
});